import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'

const baseURL = process.env.REACT_APP_BASE_URL
const fetchOrgTreeURL = `${baseURL}/api/org/get-org-tree`

export const fetchOrgTreeData = createAsyncThunk(
  'orgTree/fetchData',
  async (_, { getState, rejectWithValue }) => {
    const state = getState()
    const accessToken = state?.auth?.accessToken
    const associateId =
      state?.user?.data?.data?.userLoginDetailModel?.userName?.replace(
        /[^\d]/g,
        ''
      )

    if (!associateId) {
      return rejectWithValue('Missing associateId')
    }

    try {
      const fetchUrl = `${fetchOrgTreeURL}?associateId=${associateId}`

      const response = await axios.get(fetchUrl, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          'Content-Type': 'application/json',
        },
      })
      return response?.data?.data
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message)
    }
  }
)

const orgTreeSlice = createSlice({
  name: 'orgTree',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchOrgTreeData.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchOrgTreeData.fulfilled, (state, action) => {
        state.loading = false
        state.data = action.payload
      })
      .addCase(fetchOrgTreeData.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
  },
})

export const selectOrgTree = (state) => state.orgTree

export default orgTreeSlice.reducer
